<template>
  <div class="community-manage-container">
    <!-- 查询条件 -->
    <el-card>
      <div slot="header" class="clearfix">
        <span>{{ $t("communityManage.search.title") }}</span>
        <div style="float: right"></div>
      </div>

      <!-- 第一行查询条件 -->
      <el-form
        :inline="true"
        :model="communityManageInfo.conditions"
        class="search-form"
      >
        <el-form-item label="项目编码">
          <el-input
            v-model="communityManageInfo.conditions.communityId"
            :placeholder="$t('communityManage.search.communityId')"
            clearable
          />
        </el-form-item>

        <el-form-item label="项目名称">
          <el-input
            v-model="communityManageInfo.conditions.name"
            placeholder="项目名称"
            clearable
          />
        </el-form-item>

        <el-form-item label="物业公司">
          <el-input
            v-model="communityManageInfo.conditions.storeName"
            placeholder="物业公司"
            clearable
          />
        </el-form-item>

        <el-form-item label="创建时间">
          <el-date-picker
            v-model="communityManageInfo.conditions.createTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            clearable
            style="width: 280px"
          />
        </el-form-item>

        <el-form-item label="社区">
          <el-input
            v-model="communityManageInfo.conditions.communityQuery"
            placeholder="社区查询"
            clearable
          />
        </el-form-item>

        <el-form-item label="城市">
          <area-select @selectArea="selectArea" />
        </el-form-item>

        <el-form-item label="附近地标">
          <el-input
            v-model="communityManageInfo.conditions.nearbyLandmarks"
            placeholder="附近地标"
            clearable
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="_queryCommunityMethod">
            {{ $t("common.search") }}
          </el-button>
          <el-button @click="_resetCommunityMethod"> 重置 </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 项目信息 -->
    <el-card>
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t("communityManage.list.title") }}</span>
        <div style="float: right">
          <el-button
            type="primary"
            size="small"
            @click="_openAddCommunityModal"
          >
            {{ $t("communityManage.list.addCommunity") }}
          </el-button>
        </div>
      </div>

      <el-table
        :data="communityManageInfo.communitys"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="communityId"
          :label="$t('communityManage.table.communityId')"
          align="center"
        />
        <el-table-column
          prop="name"
          :label="$t('communityManage.table.name')"
          align="center"
        />
        <el-table-column
          prop="storeName"
          :label="$t('communityManage.table.storeName')"
          align="center"
        >
          <template #default="{ row }">
            {{ row.storeName || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="nearbyLandmarks"
          :label="$t('communityManage.table.nearbyLandmarks')"
          align="center"
        />
        <el-table-column
          prop="cityName"
          :label="$t('communityManage.table.cityCode')"
          align="center"
        />
        <el-table-column
          prop="createTime"
          :label="$t('communityManage.table.createTime')"
          align="center"
        />
        <el-table-column
          v-for="(item, index) in communityManageInfo.listColumns"
          :key="index"
          :label="formatColumnName(item.specName)"
          align="center"
        >
          <template #default="{ row }">
            {{ row.listValues[index] }}
          </template>
        </el-table-column>

        <el-table-column
          prop="stateName"
          :label="$t('communityManage.table.state')"
          align="center"
        />
        <el-table-column
          :label="$t('common.operation')"
          align="center"
          width="150"
        >
          <template #default="{ row }">
            <el-button-group>
              <el-button size="mini" @click="_openDeleteCommunityModel(row)">
                {{ $t("common.delete") }}
              </el-button>
              <el-button size="mini" @click="_openEditCommunityModel(row)">
                {{ $t("common.edit") }}
              </el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="pagination.current"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>

    <!-- 组件 -->
    <add-community ref="addCommunity" @listData="_queryCommunityMethod" />
    <edit-community ref="editCommunity" @listData="_queryCommunityMethod" />
    <delete-community ref="deleteCommunity" @listData="_queryCommunityMethod" />
  </div>
</template>

<script>
import { listCommunitys } from "@/api/community/communityManageApi";
import AreaSelect from "@/components/community/areaSelect";
import AddCommunity from "@/components/community/addCommunity";
import EditCommunity from "@/components/community/editCommunity";
import DeleteCommunity from "@/components/community/deleteCommunity";
import { getAttrSpecList } from "@/api/dev/attrSpecApi";

export default {
  name: "CommunityManageList",
  components: {
    AreaSelect,
    AddCommunity,
    EditCommunity,
    DeleteCommunity,
  },
  data() {
    return {
      communityManageInfo: {
        communitys: [],
        storeTypeCd: "",
        conditions: {
          name: "",
          cityCode: "",
          communityId: "",
          storeName: "",
          createTime: "",
          communityQuery: "",
          nearbyLandmarks: "",
        },
        listColumns: [],
      },
      pagination: {
        current: 1,
        size: 10,
        total: 0,
      },
    };
  },
  created() {
    this._initMethod();
  },
  methods: {
    async _initMethod() {
      await this._getColumns();
      this._listCommunitys(this.pagination.current, this.pagination.size);
    },
    _listCommunitys(page, size) {
      console.log('原始 conditions：', this.communityManageInfo.conditions);

      const params = {
        ...this.communityManageInfo.conditions,
        page,
        row: size,
      };

      console.log('复制后 params 的 createTime：', params.createTime);
      console.log('createTime 类型：', typeof params.createTime);
      console.log('createTime 是否为数组：', Array.isArray(params.createTime));

      // 处理日期范围，将 createTime 拆分为 startTime 和 endTime
      if (params.createTime && Array.isArray(params.createTime) && params.createTime.length === 2) {
        params.startTime = params.createTime[0];
        params.endTime = params.createTime[1];
        delete params.createTime;
        console.log('时间转换成功 - startTime:', params.startTime, 'endTime:', params.endTime);
      } else {
        console.log('时间转换失败 - createTime 不符合条件');
      }

      // 处理社区查询，将 communityQuery 转换为 specName
      if (params.communityQuery && params.communityQuery.trim()) {
        params.specName = params.communityQuery;
        delete params.communityQuery;
      }

      console.log('最终查询参数：', params);

      listCommunitys(params)
        .then((res) => {
          this.communityManageInfo.total = res.total;
          this.communityManageInfo.records = res.records;
          this.communityManageInfo.communitys = res.communitys;
          this.dealCommunityAttr(res.communitys);
          this.pagination.total = res.total;
        })
        .catch((error) => {
          console.log("请求失败处理", error);
        });
    },
    selectArea(area) {
      this.communityManageInfo.conditions.cityCode = area.selectArea;
    },
    _openAddCommunityModal() {
      this.$refs.addCommunity.openModal();
    },
    _openEditCommunityModel(community) {
      this.$refs.editCommunity.openModal(community);
    },
    _openDeleteCommunityModel(community) {
      this.$refs.deleteCommunity.openModal(community);
    },
    _queryCommunityMethod() {
      this.pagination.current = 1;
      this._listCommunitys(this.pagination.current, this.pagination.size);
    },
    _resetCommunityMethod() {
      this.communityManageInfo.conditions = {
        name: "",
        cityCode: "",
        communityId: "",
        storeName: "",
        createTime: "",
        communityQuery: "",
        nearbyLandmarks: "",
      };
      this._listCommunitys(this.pagination.current, this.pagination.size);
    },
    dealCommunityAttr(communitys) {
      communitys.forEach((item) => {
        this._getColumnsValue(item);
      });
    },
    _getColumnsValue(community) {
      community.listValues = [];
      if (
        !community.communityAttrDtos ||
        community.communityAttrDtos.length < 1
      ) {
        this.communityManageInfo.listColumns.forEach(() => {
          community.listValues.push("");
        });
        return;
      }
      this.communityManageInfo.listColumns.forEach((column) => {
        let tmpValue = "";
        community.communityAttrDtos.forEach((attrItem) => {
          if (column.specCd === attrItem.specCd) {
            tmpValue = attrItem.value;
          }
        });
        community.listValues.push(tmpValue);
      });
    },
    async _getColumns() {
      const { data } = await getAttrSpecList({
        page: 1,
        row: 100,
        tableName: "building_community_attr",
      });
      this.communityManageInfo.listColumns = [];
      data.forEach((item) => {
        if (item.listShow === "Y") {
          this.communityManageInfo.listColumns.push({
            specCd: item.specCd,
            specName: item.specName,
          });
        }
      });
    },
    handleSizeChange(val) {
      this.pagination.size = val;
      this._listCommunitys(this.pagination.current, val);
    },
    handleCurrentChange(val) {
      this.pagination.current = val;
      this._listCommunitys(val, this.pagination.size);
    },
    // 格式化列名，去掉"编码"后缀
    formatColumnName(columnName) {
      if (columnName === "社区编码") {
        return "社区";
      }
      if (columnName === "城市编码") {
        return "城市";
      }
      if (columnName === "项目编码") {
        return "项目";
      }
      return columnName;
    },
  },
};
</script>

<style lang="scss" scoped>
.community-manage-container {
  padding: 20px;

  .el-card {
    margin-bottom: 20px;
  }

  .search-form {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .el-form-item {
      margin-bottom: 10px;
      margin-right: 10px;
    }
  }
}
</style>
